module.exports = window['i18n-react'];